import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { AuthRepository } from '@domain/repositories/auth.repository';
import { SettlementRepository } from '@domain/repositories/settlement.repository';
import { StoreCategoryRepository } from '@domain/repositories/store-category.repository';
import { StoreComplaintRepository } from '@domain/repositories/store-complaint.repository';
import { StoreRepository } from '@domain/repositories/store.repository';
import { StreamingRepository, QuizQuestionRepository } from '@domain/repositories/streaming.repository';
import { UserRepository } from '@domain/repositories/user.repository';
import { UserTagRepository } from '@domain/repositories/user-tag.repository';

import { AuthApiRepository } from '@data/repositories/auth-api.repository';
import { QuizQuestionApiRepository } from '@data/repositories/quiz-question-api.repository';
import { SettlementApiRepository } from '@data/repositories/settlement-api.repository';
import { StoreApiRepository } from '@data/repositories/store-api.repository';
import { StoreCategoryApiRepository } from '@data/repositories/store-category-api.repository';
import { StoreComplaintApiRepository } from '@data/repositories/store-complaint-api.repository';
import { StreamingApiRepository } from '@data/repositories/streaming-api.repository';
import { UserApiRepository } from '@data/repositories/user-api.repository';
import { UserTagApiRepository } from '@data/repositories/user-tag-api.repository';

/** Binds domain ports to data-layer adapters (swap implementations here). */
export function provideDataRepositories(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: AuthRepository, useClass: AuthApiRepository },
    { provide: UserRepository, useClass: UserApiRepository },
    { provide: UserTagRepository, useClass: UserTagApiRepository },
    { provide: StoreRepository, useClass: StoreApiRepository },
    { provide: StoreCategoryRepository, useClass: StoreCategoryApiRepository },
    { provide: StoreComplaintRepository, useClass: StoreComplaintApiRepository },
    { provide: SettlementRepository, useClass: SettlementApiRepository },
    { provide: StreamingRepository, useClass: StreamingApiRepository },
    { provide: QuizQuestionRepository, useClass: QuizQuestionApiRepository },
  ]);
}
